<script lang="ts">
    import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
    import { Button } from "@/components/ui/button";

    interface Props {
        title: string;
        icon?: any;
        confirmText?: string;
        cancelText?: string;
        message?: string;
        size?: 'default' | 'sm';
        onConfirm?: () => void;
    }

    let {
        title,
        icon,
        confirmText = "Confirm",
        cancelText = "Cancel",
        message = "Are you sure?",
        size = 'default',
        onConfirm = () => {}
    }: Props = $props();

    let isOpen = $state(false);

    function handleConfirm() {
        onConfirm();
        isOpen = false;
    }

    let isSmall = $derived(size === 'sm');
</script>

<Popover bind:open={isOpen}>
    <PopoverTrigger>
        <Button
            {size}
            class="flex items-center rounded-lg font-medium hover:bg-accent transition-all duration-200 {isSmall ? 'gap-x-1.5 px-2 py-1 text-xs' : 'gap-x-3 px-3 py-2 text-sm'}"
        >
            {#if icon}
                {@const Icon = icon}
                <Icon class="transition-all duration-200 {isSmall ? 'w-3.5 h-3.5' : 'w-4 h-4'}" />
            {/if}
            {title}
        </Button>
    </PopoverTrigger>

    <PopoverContent class="flex flex-col gap-2 w-48">
        <p class="text-sm">{message}</p>
        <div class="flex justify-end gap-2">
            <Button variant="secondary" size="sm" onclick={() => (isOpen = false)}>
                {cancelText}
            </Button>
            <Button variant="destructive" size="sm" onclick={handleConfirm}>
                {confirmText}
            </Button>
        </div>
    </PopoverContent>
</Popover>
